// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"49726f0bb958a54e","931":"f186200e8031e6bf"}[chunkId] + ".css";
};